import { render, staticRenderFns } from "./CallTestScenarios.vue?vue&type=template&id=c2508b5a&scoped=true&"
import script from "./CallTestScenarios.vue?vue&type=script&lang=js&"
export * from "./CallTestScenarios.vue?vue&type=script&lang=js&"
import style0 from "./CallTestScenarios.vue?vue&type=style&index=0&id=c2508b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2508b5a",
  null
  
)

export default component.exports